import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownEventContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownEventContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownEventContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownEventContracts/${id}`, request)
}

export {get, post, put, patch}
